import { useUnsavedChanges } from "../../common/unsavedChangesContext";
import { GoabCallout, GoabText } from "@abgov/react-components";
import DisplayContent from "../../components/DynamicForm/Forms/DisplayContent";
import { InternalApplicationStatuses } from "../../common/constants/statuses";

const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
  }).format(amount);

const buildAdditionalInfo = (internalStatus, voucher, benefits) => {
  if (internalStatus === InternalApplicationStatuses.VoucherIssued && voucher) {
    const instructions = voucher.instructionsForApplicant
      ? `<p>${voucher.instructionsForApplicant}</p>`
      : "";
    return `<p><strong>Store/vendor location: </strong>${voucher.storeVendorLocation ?? ""}</p>${instructions}`;
  }

  if (
    (internalStatus === InternalApplicationStatuses.PaymentSent ||
      internalStatus === InternalApplicationStatuses.PaymentComplete) &&
    benefits?.length > 0
  ) {
    const benefitItems = benefits
      .map((benefit) => `<li>${benefit.publicName || benefit.label}</li>`)
      .join("");
    const total = benefits.reduce(
      (sum, benefit) => sum + (Number(benefit.amount) || 0),
      0,
    );
    return `<ul>${benefitItems}</ul><p><strong>Total: ${formatCurrency(total)}</strong></p>`;
  }

  return "";
};

const StatusCalloutWidget = ({ context = {} }) => {
  const { hasUnsavedChanges } = useUnsavedChanges() || {};

  if (hasUnsavedChanges) {
    return null;
  }

  const internalStatus = context?.internalStatus;
  const { voucher, benefits, supportInfo = "" } = context ?? {};

  const configuredCallouts = context?.statusCallouts ?? [];
  const activeCallouts = configuredCallouts
    .filter((c) => c?.internalStatus === internalStatus)
    .sort((a, b) => (a.order ?? 1) - (b.order ?? 1));

  if (!activeCallouts.length) {
    return null;
  }

  return (
    <>
      {activeCallouts.map((callout) => {
        const type = callout.type || "information";
        const heading = callout.heading || "";
        let content = callout.htmlContent || "";

        const additionalInfo = buildAdditionalInfo(
          internalStatus,
          voucher,
          benefits,
        );
        const supportContent =
          callout.isSupportInformationIncluded && supportInfo
            ? supportInfo
            : "";

        content = [content, additionalInfo, supportContent]
          .filter(Boolean)
          .join("<br/>");

        return (
          <GoabCallout
            key={callout.id}
            emphasis={callout.emphasis}
            type={type}
            heading={heading}
            size="large"
            mb="xl"
          >
            <GoabText mb='none' mt='none'>
              <DisplayContent content={content} />
            </GoabText>
          </GoabCallout>
        );
      })}
    </>
  );
};

export default StatusCalloutWidget;
